import * as actionTypes from "../actionTypes";

const initialState = {
    careers: [],
    error: null,
    loading: false,
    saving: false,
    isLoadingSaveCareer:false,
    savingIds: [],
    saveId: {},
};

const careersReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case actionTypes.GET_CAREERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case actionTypes.GET_CAREERS_SUCCESS:
            return {
                ...state,
                loading: false,
                careers: {
                    ...payload,
                    careers:
                        payload.offset > 0
                            ? [...(state.careers?.careers || []), ...payload.careers]
                            : payload.careers,
                },
            };
        case actionTypes.GET_CAREERS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };

        case actionTypes.CLEAR_CAREERS:
            return {
                ...state,
                careers: [],
            };

        case actionTypes.SET_CAREERS_REQUEST:
            return {
                ...state,
                saveId:payload,
                isLoadingSaveCareer:true
            };
        case actionTypes.SET_CAREERS_SUCCESS:
            return {
                ...state,
                isLoadingSaveCareer:false,
                careers: {
                    ...state.careers,
                    careers: state.careers.careers.map((item) =>
                        item.id === payload.career_key
                            ? {
                                ...item,
                                interested: payload.interested,
                            }
                            : item
                    ),
                },
            };

        case actionTypes.SET_CAREERS_ERROR:
            return {
                ...state,
                saveId:{},
                isLoadingSaveCareer:false,
                savingIds: state.savingIds.filter((id) => id !== payload?.career_key),
            };

        default:
            return state;
    }
};

export default careersReducer;